import { contentAi } from '@mi-front/api-clients';

/** Whether Content AI is enabled for a station (per-station config from the API). */
export function useIsContentAiForStationEnabled(stationId: string) {
  const config = contentAi.useStationConfigGet(stationId);

  return config.data?.enabled ?? false;
}
